export const isAvatarMuted = state => state.get('isAvatarMuted')
